// chatWidget.js
(function(){
    // ——— Helpers ———
    function detectLang(){
      const p = location.pathname;
      if (p.startsWith('/en')) return 'en';
      if (p.startsWith('/fr')) return 'fr';
      if (p.startsWith('/de')) return 'de';
      return 'it';
    }
    function uuidv4(){
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,c=>{
        const r = Math.random()*16|0, v = c=='x'? r : (r&0x3|0x8);
        return v.toString(16);
      });
    }
  
    // ——— Mount & IDs ———
    const mount = document.getElementById('somml-container');
    let userId = document.cookie.match(/chatUserId=([^;]+)/);
    if (userId) userId = userId[1];
    else {
      userId = uuidv4();
      document.cookie = `chatUserId=${userId};path=/;max-age=${365*24*60*60}`;
    }
    const sessionId = uuidv4();
  
    // ——— Build UI ———
    const wrapper = document.createElement('div');
    wrapper.style.margin = '20px 0';
    // CENTER the launcher:
    wrapper.style.textAlign = 'center';

    const uiLang = detectLang();  // 'it','en','fr','de'

    const launchLabels = {
        it: 'Chiedi al Sommelier AI',
        en: 'Ask to Sommelier AI',
        fr: 'Demandez au Sommelier IA',
        de: 'Fragen Sie den Sommelier AI'
    };

    const inputPlaceholders = {
        it: 'Scrivi un messaggio…',
        en: 'Type a message…',
        fr: 'Écrivez un message…',
        de: 'Nachricht eingeben…'
    };
  
    const link = document.createElement('a');
    link.href = 'javascript:void(0)';
    link.innerHTML = `
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 509.727 509.727"
        preserveAspectRatio="xMidYMid meet"
        style="
        vertical-align: middle;
        margin-right: 8px;
        width: 24px;
        height: 24px;
        fill: currentColor;
        transform: translateY(-4px);
        "
    >
        <g>
        <path d="M232.406 179.611h67.469v330.116h-67.469zM101.203 162.744C45.4 162.744 0 208.144 0 263.947v245.78h67.469V406.114h67.469v103.614h67.469v-245.78c-.001-55.804-45.4-101.204-101.204-101.204zm33.735 175.901H67.469v-74.698c0-18.601 15.133-33.734 33.734-33.734s33.734 15.133 33.734 33.734v74.698zM429.568 80.159 385.727 0l-43.84 80.159L261.727 124l80.16 43.841L385.727 248l43.841-80.159L509.727 124z"/>
        </g>
    </svg>
    <span style="vertical-align:middle;">${launchLabels[uiLang]}</span>
    `;

    Object.assign(link.style, {
    display:        'inline-flex',
    alignItems:     'center',
    justifyContent: 'center',
    padding:        '10px 16px',
    backgroundColor:'#86023f',
    color:          '#fff',
    borderRadius:   '8px',
    textDecoration: 'none',
    fontWeight:     '600',
    fontSize:       '16px',
    cursor:         'pointer',
    transition:     'background-color 0.2s ease'
    });

    link.addEventListener('mouseenter', () => {
    link.style.backgroundColor = '#a93863';
    });
    link.addEventListener('mouseleave', () => {
    link.style.backgroundColor = '#86023f';
    });

    wrapper.appendChild(link);
  
    // Widget container
    const widget = document.createElement('div');
    widget.id = 'somml-widget';
    Object.assign(widget.style, {
      overflow: 'hidden',
      maxHeight: '0',
      transition: 'max-height 0.3s ease',
      borderLeft: '1px solid #ddd',
      borderRight: '1px solid #ddd',
      borderBottom: '1px solid #ddd',
      background: '#fff',
      display: 'flex',
      flexDirection: 'column',
      height: '500px'
    });
  
    // Header
    const header = document.createElement('div');
    Object.assign(header.style, {
      padding: '12px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      background: '#f9f9f9',
      borderBottom: '1px solid #ddd'
    });
    const title = document.createElement('span');
    title.textContent = 'Bottle of Italy Sommelier AI';
    const btnClose = document.createElement('button');
    btnClose.textContent = '×';
    Object.assign(btnClose.style, {
      background: 'none',
      border: 'none',
      fontSize: '24px',
      cursor: 'pointer',
      lineHeight: '1'
    });
    header.appendChild(title);
    header.appendChild(btnClose);
    widget.appendChild(header);
  
    // Chat area
    const chat = document.createElement('div');
    Object.assign(chat.style, {
      padding: '12px',
      overflowY: 'auto',
      flex: '1',
      display: 'flex',
      flexDirection: 'column'
    });
    widget.appendChild(chat);
  
    // Input area
    const inputWrap = document.createElement('div');
    Object.assign(inputWrap.style, {
      display: 'flex',
      borderTop: '1px solid #ddd',
      alignItems: 'center',
      padding: '8px'
    });
    const input = document.createElement('input');
    Object.assign(input.style, {
      flex: '1',
      border: '1px solid #ccc',
      borderRadius: '4px',
      padding: '8px 12px',
      fontSize: '16px',
      marginRight: '8px',
      background: '#fafafa',
      WebkitTextSizeAdjust: '100%'
    });
    input.placeholder = inputPlaceholders[uiLang];
    const btnSend = document.createElement('button');
    btnSend.type = 'button';
    btnSend.innerHTML = '➤';
    Object.assign(btnSend.style, {
      width: '36px',
      height: '36px',
      border: 'none',
      background: 'none',
      fontSize: '20px',
      cursor: 'pointer',
      color: '#007bff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    });
    inputWrap.appendChild(input);
    inputWrap.appendChild(btnSend);
    widget.appendChild(inputWrap);
  
    wrapper.appendChild(widget);
    mount.appendChild(wrapper);
  
    // ——— Conversation State ———
    const conversation = [];
    let initialized = false;
  
    // ——— Helpers ———
    function addMsg(who, text) {
      const msg = document.createElement('div');
      let html = text
        .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
        .replace(/\n/g,'<br>')
        .replace(/(https?:\/\/[^\s<]+)/g,'<a href="$1" target="_blank">$1</a>');
      msg.innerHTML = html;
      Object.assign(msg.style, {
        padding: '8px',
        margin: '6px 0',
        borderRadius: '6px',
        maxWidth: '80%',
        alignSelf: who==='user'?'flex-end':'flex-start',
        background: who==='user'?'#e8f0fe':'#f1f1f1',
        fontSize: '14px',
        textAlign: 'left'
      });
      chat.appendChild(msg);
      if (who === 'assistant') {
        // smooth-scroll so the top of this bubble is at the top of the viewport
        msg.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        // for user messages, still scroll to bottom
        chat.scrollTop = chat.scrollHeight;
      }
    }
  
    // Show typing indicator
    let typingTimeout, dotInterval;
    function showTyping() {
      const ind = document.createElement('div');
      ind.id = 'typing-indicator';
      Object.assign(ind.style, {
        padding: '8px',
        margin: '6px 0',
        borderRadius: '6px',
        maxWidth: '80%',
        alignSelf: 'flex-start',
        background: '#f1f1f1',
        fontStyle: 'italic',
        color: '#666',
        fontSize: '14px'
      });
      chat.appendChild(ind);
      chat.scrollTop = chat.scrollHeight;
      let dots = 0;
      dotInterval = setInterval(()=>{
        dots = (dots+1)%4;
        ind.textContent = 'AI is typing' + '.'.repeat(dots);
      }, 400);
      typingTimeout = ind;
    }
  
    function hideTyping() {
      clearInterval(dotInterval);
      const ind = document.getElementById('typing-indicator');
      if (ind) ind.remove();
    }
  
    // ——— Send Message ———
    async function sendMsg(){
      const txt = input.value.trim();
      if (!txt) return;
      addMsg('user', txt);
      conversation.push({ role:'user', content: txt });
      input.value = '';
  
      showTyping();
  
      try {
        const res = await fetch('https://bottleofitaly-chatbot-0a5bf6e64b1f.herokuapp.com/chat', {
          method:'POST',
          headers:{ 'Content-Type':'application/json' },
          body: JSON.stringify({
            message: txt,
            productId: window.currentProductId||null,
            conversationHistory: conversation,
            userId, 
            sessionId,
            language: uiLang
          })
        });
        hideTyping();
        if (!res.ok) {
          console.error('Chat error', await res.text());
          addMsg('assistant','Oops, server error.');
          return;
        }
        const { reply } = await res.json();
        addMsg('assistant', reply);
        conversation.push({ role:'assistant', content: reply });
      } catch(err) {
        hideTyping();
        console.error('Network error', err);
        addMsg('assistant','Oops, network error.');
      }
    }
  
    btnSend.addEventListener('click', sendMsg);
    input.addEventListener('keydown', e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        sendMsg();
      }
    });
  
    // ——— Open & Greet ———
    link.addEventListener('click', ()=>{
      if (!initialized) {
        const lang = detectLang();
        const intros = {
            it: 'Ciao! Sono il tuo Sommelier AI. Puoi chiedermi maggiori informazioni su questo prodotto o con che piatti abbinarlo o ricette perfette.',
            en: 'Hi! I am your AI Sommelier. You can ask me more information about this product or what dishes to pair it with or perfect recipes.',
            fr: 'Bonjour ! Je suis votre sommelier AI. Vous pouvez me demander plus d informations sur ce produit, sur les plats qui l accompagnent ou sur les recettes parfaites.',
            de: 'Hallo! Ich bin Ihr AI-Sommelier. Sie können mich mehr über dieses Produkt fragen, oder welche Gerichte man damit kombinieren kann oder welche Rezepte perfekt sind.'
        };
        addMsg('assistant', intros[lang]||intros.en);
        initialized = true;
      }
      widget.style.maxHeight = '500px';
    });
  
    btnClose.addEventListener('click', ()=>{
      widget.style.maxHeight = '0';
    });
  
  })();